import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Typography } from "antd"
import { DashboardDetailIcon, DashboardDetailType } from '../utils'
import { Icon } from '@iconify/react';
import { Const } from '@mods/constants';
import { trans } from '../../../wrappers/components';

const languageKey = Const["dashboard"].lngKey;

const { Title, Text } = Typography

const initialData = {
  [DashboardDetailType.POS_BILL_COUNT]: 0,
  [DashboardDetailType.POS_BILL_TOTAL]: 0,
  [DashboardDetailType.DIGITAL_MENU_BILL_COUNT]: 0,
  [DashboardDetailType.DIGITAL_MENU_BILL_TOTAL]: 0,
}

export default function DashboardBillSummary({ records }) {
  const [billDetails, setBillDetails] = useState(initialData)

  useEffect(() => {
    let data = {};
    records.forEach(record => {
      if (initialData[record.type] !== undefined) {
        data[record.type] = record.value
      }
    })
    setBillDetails(data)
  }, [records])


  const SummaryCard = ({ total, count, title }) => {
    return (

      <Card
        hoverable
        style={ { borderRadius: '8px', textAlign: "center" } }
      >
        <section className="bill-details">
          <Icon icon="mingcute:bill-2-line" fontSize={ 40 } />
          <Title level={ 4 }>{ title }</Title>
          <Row className=''>
            <Col xs={ 24 } sm={ 12 } >
              <div className='dash-info'>
                <Title level={ 5 }>{ count }</Title>
                <Text>{ trans(`${languageKey}.billCount`) }</Text>
              </div>
            </Col>
            <Col xs={ 24 } sm={ 12 }>
              <div className='dash-info'>
                <Title level={ 5 }>{ total }</Title>
                <Text>{ trans(`${languageKey}.billTotal`) }</Text>
              </div>
            </Col>

          </Row>
        </section>
      </Card>
    )
  }

  return (
    <div>
      <div style={ { padding: '20px', background: '#f0f2f5', marginTop: "20px" } }>
        <Row gutter={ 16 }>
          <Col xs={ 24 } sm={ 12 }>
            <SummaryCard count={ billDetails[DashboardDetailType.DIGITAL_MENU_BILL_COUNT] } total={ billDetails[DashboardDetailType.DIGITAL_MENU_BILL_TOTAL] } title={ trans(`${languageKey}.digitalMenuDetails`) } />
          </Col>
          <Col xs={ 24 } sm={ 12 }>
            <SummaryCard count={ billDetails[DashboardDetailType.POS_BILL_COUNT] } total={ billDetails[DashboardDetailType.POS_BILL_TOTAL] } title={ trans(`${languageKey}.posBillDetails`) } />
          </Col>
        </Row>
      </div>
    </div>
  )
}
